export interface AvisVerifiesGetReviews {
    idWebsite: string;
    query: 'average' | 'reviews';
    product: string[];
    plateforme?: string;
    order?: AVIS_VERIFIES_ORDER;
    filter?: number;
    offset?: number;
    limit?: number;
}

export enum AVIS_VERIFIES_ORDER {
    DATE_ASC = 'date_asc',
    DATE_DESC = 'date_desc',
    RATE_ASC = 'rate_asc',
    RATE_DESC = 'rate_desc',
    HELPFULL = 'most_helpful',
}

export enum AVIS_VERIFIER_AGE {
    LESS17 = '- de 17 ans',
    BETWEEN1824 = '18 - 24',
    BETWEEN2534 = '25 - 34',
    BETWEEN3544 = '35 - 44',
    BETWEEN4554 = '45 - 54',
    BETWEEN5564 = '55 - 64',
    MORE64 = '64 ou +',
}

export type AvisVerifiesGetReviewsBody = AvisVerifiesGetReviewsRoot[];

export interface AvisVerifiesGetAverageBody {
    [key: string]: Average[];
}

export interface Average {
    rate: string;
    count: string;
}

export interface AvisVerifiesGetReviewsRoot {
    reviews: Review[];
    stats: number[];
}

export interface Review {
    rewarded_review: string;
    count_helpful_yes: string;
    firstname: string;
    description: string;
    order_ref: string;
    rate: string;
    review: string;
    product_review_sexe: string;
    email: string;
    product_review_recommandation_ami: string;
    product_review_temps_utilisation: string;
    brand_review_pseudo: string;
    brand_review_profil: string;
    info10: string;
    count_helpful_no: string;
    hide_personnal_data: string;
    product_review_design: string;
    product_review_facilite_installation: string;
    product_review_autonomie: string;
    product_review_qualite_produit: string;
    product_review_qualite_appareil2: string;
    product_review_facilitedutilisation: string;
    url_product: string;
    brand_name: string;
    lastname: string;
    info9: string;
    info8: string;
    order_date: string;
    medias: string;
    info7: string;
    id_review_product: string;
    review_date: string;
    info6: string;
    brand_review_title: string;
    id_product: string;
    brand_review_age: string;
    product_review_recommandation_telephone: string;
    info1: string;
    id_review: string;
    product_review_title: string;
    info5: string;
    category: string;
    sign_helpful: string;
    info4: string;
    publish_date: string;
    info3: string;
    info2: string;
}
